'use strict';

module.exports = /* @ngInject */ function (apiConfig, sseService, httpService) {

    function getBaseShipping() {
        return `${apiConfig.$get().apiUrl}/customer/address/shipping`
    }

    /**
     * Get all shipping addresses activated for the current user
     * @typedef {
     *     {
	 *        shippingAddressCode: string,
     *        companyAddressWithContact: {
	 *            id: number,
     *            companyAddress: {
     *                companyName: {
     *                    line1: string,
     *                    line2: string
     *                },
     *                address: {
     *                    street: string,
     *                    zip: string,
     *                    city: string,
     *                    state: string,
     *                    country: {
     *                        iso3166: string,
     *                        known: boolean,
     *                        standardized: boolean,
     *                        value: string
     *                    }
     *                },
     *                emailAddress: {
     *                    value: string
     *                }
     *            },
     *            personName: {
     *                firstname: string,
     *                lastname: string
     *            }
     *        }
     *     }
     * } ShippingAddressResponse
     *
     * @return {
     *     Promise<ShippingAddressResponse[]>
     * }
     */
    function getAllShipping() {
        const url = `${getBaseShipping()}/all`;
        return httpService.get(url, {
            isArray: true
        });
    }

    /**
     * Get my default shipping address
     @return {
      *     Promise<ShippingAddressResponse>
      * }
     */
    function getMyDefaultShipping() {
        const url = `${getBaseShipping()}/default`;
        return httpService.get(url);
    }

    return {
        getAllShipping,
        getMyDefaultShipping
    }
}
